// extracted by mini-css-extract-plugin
export const formInput = "Form-module--formInput--3wlQn";
export const formLabel = "Form-module--formLabel--2tImj";
export const formCheckbox = "Form-module--formCheckbox--25by8";
export const formRadio = "Form-module--formRadio--3o7wt";
export const selectInput = "Form-module--selectInput--3QGo-";